
import empresa from "./empresa";
import sucursal from "./sucursal";
import punto_venta from "./punto_venta";
import empresa_moneda from "./empresa_moneda";
import empresa_moneda_detalle from "./empresa_moneda_detalle";
import tipo_pago from "./tipo_pago";
import punto_venta_tipo_pago from "./punto_venta_tipo_pago";
export default {
    empresa,
    sucursal,
    punto_venta,
    empresa_moneda,
    empresa_moneda_detalle,
    tipo_pago,
    punto_venta_tipo_pago
}